module.exports = __webpack_public_path__ + "badge_revenda.svg";